// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    class='exclamation'
    viewBox='1.06 0.73 4.04 14.21'
    ...attributes
  ><path
      fill='var(--icon-color, #000)'
      d='M4.505 9.037H1.693L1.11.729h3.983zM1.06 12.978a1.93 1.93 0 0 1 .518-1.459 2.1 2.1 0 0 1 1.51-.5 2.05 2.05 0 0 1 1.481.507c.369.39.559.916.524 1.452a1.93 1.93 0 0 1-.53 1.435c-.4.367-.933.556-1.475.524a2.07 2.07 0 0 1-1.5-.513 1.92 1.92 0 0 1-.528-1.446'
    /></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'Exclamation';
export default IconComponent;
